'use strict';

filterHierarchyCategoryItem.$inject = ["common", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterHierarchyCategoryItem = filterHierarchyCategoryItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterHierarchyCategoryItem(common, $stateParams) {
    var clazz = function FilterHierarchyCategoryItem() {
        var defaults = {
            id: '',
            name: '',
            isSelected: false,
            isParent: true,
            children: [],
            isVIPSeller: false,
            parentId: 0,
            childSelected: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        isFilterSelected: function isFilterSelected(qsFilter) {
            qsFilter;
            // this.$stateParams.filter
        },
        hasChildSelected: function hasChildSelected() {
            var childSearch = this.children.find(function (child) {
                return child.isSelected === true;
            });

            if (childSearch) {
                return true;
            } else {
                var hasChildSelected = false;
                this.children.forEach(function (child) {
                    if (child.hasChildSelected(child)) {
                        hasChildSelected = true;
                    }
                });

                return hasChildSelected;
            }
        }
    });

    clazz.create = function (resource, level, formatNameToPascalCase) {
        var _this = this;

        var item = new clazz();
        item.id = resource.id;

        if (formatNameToPascalCase) {
            item.name = common.toPascalCase(resource.name);
        } else {
            item.name = resource.name;
        }

        // check if there are children and add them
        if (resource.children) {
            resource.children = _lodash2.default.orderBy(resource.children, 'name');
            item.children = _lodash2.default.map(resource.children, function (item) {
                return _this.create(item, null, 0, formatNameToPascalCase);
            });
        }

        item.isSelected = $stateParams.categoryId === item.id ? true : false;
        item.parentId = resource.parentId;
        item.isVIPSeller = resource.isVIPSeller;
        item.isParent = resource.parentId === 0 ? true : false;
        item.level = level || 1;
        item.childSelected = item.hasChildSelected();
        return item;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/filterHierarchyCategoryItemModel.js
// module id = 750
// module chunks = 0